import React from 'react'
import { Link } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const SravastiResidency = () => {
    const carouselSravastiResidency = {
        items: 1,
        loop: true,
        dots: false,
        margin: 0,
        autoplay: true,
        nav: true,
        navText: ['<i class="ti-angle-left" aria-hidden="true"></i>', '<i class="ti-angle-right" aria-hidden="true"></i>'],
        responsiveClass: true,
        responsive: {
            0: {
                dots: false,
            },
            600: {
                dots: false,
            },
            1000: {
                dots: false,
            }
        }
    };
    const carouselSravastiResidencythumb = {
        loop: true,
        margin: 10,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: true,
        navText: ["<span className='lnr ti-angle-left'></span>", "<span className='lnr ti-angle-right'></span>"],
        responsiveClass: true,
        responsive: {
            0: {
                items: 1,
            },
            600: {
                items: 2
            },
            1000: {
                items: 3
            }
        }
    };
    return (
        <>
            <header className="headerslider">
                <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidency}>
                    <div className='item'>
                        <img src='img/slider/Sravasti-slider-1.webp' loading="lazy" alt="hotel" className="img-fluid" />
                    </div>
                    <div className='item'>
                        <img src='img/slider/Sravasti-slider-3.webp' loading="lazy" alt="hotel" className="img-fluid" />
                    </div>
                    <div className='item'>
                        <img src='img/slider/Sravasti-slider-2.webp' loading="lazy" alt="hotel" className="img-fluid" />
                    </div>
                    <div className='item'>
                        <img src='img/slider/Sravasti-slider-4.webp' loading="lazy" alt="hotel" className="img-fluid" />
                    </div>

                </OwlCarousel>

                <Link to="#" data-scroll-nav="1" className="mouse smoothscroll" aria-label="Scroll to section"> <span className="mouse-icon">
                    <span className="mouse-wheel"></span> </span>
                </Link>
            </header>

            <section className="room-details1 section-padding" data-scroll-index="1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="section-title">The Sravasti Residency</div>
                        </div>
                        <div className="col-md-8">
                            <p>A serene haven nestled in the historic city of Sravasti, Uttar Pradesh. Our hotel boasts 56 comfortable rooms, perfect for travelers seeking tranquility and insight into the region's rich Buddhist heritage.</p>
                            <p>Sravasti, a sacred site in Buddhism, was where Gautama Buddha spent 24 rainy seasons, sharing wisdom and teachings. The city is home to the Jetavana monastery, a significant pilgrimage site, and the Anathapindika Stupa.
                                Stay with us and immerse yourself in the spiritual legacy of this ancient city.</p>
                            <p>At Sravasti Residency, we offer a peaceful retreat, blending modern comforts with a deep connection to the region's cultural and historical significance.
                                The Hotel is Recognized by Department of Tourism, Government of Uttar Pradesh and
                                our property is located right adjacent to Korean monastery. We are also Members of FHRAI and HRAEI.</p>
                            <p></p>
                            <div className="row">
                                <div className="col-md-6">
                                    <h6>Check-in</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-in - 2 PM</p>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                                <div className="col-md-6">
                                    <h6>Check-out</h6>
                                    <ul className="list-unstyled page-list mb-30">
                                        <li>
                                            <div className="page-list-icon"> <span className="ti-check"></span> </div>
                                            <div className="page-list-text">
                                                <p>Check-out - 12 Noon</p>
                                            </div>
                                        </li>

                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="cont">
                                        <h3>Address</h3>
                                        <p>Sravasti, Dist. - Sravasti - 271805, U.P. (India)<br />
                                            <strong>Mob. No.</strong> : <a href='tel:+91 9289300358'>+91 9289300358</a><br />
                                            <strong>Tel No.</strong> : <a href='tel:+91 6112 - 255404'>+91 6112 - 255404, 255405</a><br />
                                            <strong>  Email </strong>: <a href='mailto:thesravastiresidency@gmail.com'>thesravastiresidency@gmail.com</a><br />

                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="col-md-3 offset-md-1">
                            <h6>Facilities of The Sravasti Residency</h6>
                            <p>The Sravasti Residency provides deluxe air-condition rooms include the following facilities</p>
                            <ul className="mb-30">
                                <li> Multi Cuisine Food</li>
                                <li>24 Hour Hot & Cold Shower</li>
                                <li>Multi-lingual satellite T.V.</li>
                                <li>24 Hour Uninterrupted Power Supply</li>
                                <li>Free High Speed Wi-Fi connectivity</li>
                                <li>Hair Dryer</li>
                                <li>Laundry Services</li>
                                <li>Shopping Arcade</li>
                                <li>Tea / Coffee maker</li>
                                <li>Doctor on call</li>
                                <li>Room service</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className="rooms5 section-padding bg-white" data-scroll-index="1">
                <div className="container">
                    <div className="section-title">Room Type</div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/s-room-1.webp" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Single Room</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div className="col-md-6 col-6">
                                            <ul>
                                                <li><i class="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i class="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 col-6">
                                            <ul>
                                                <li><i class="flaticon-bed"></i> Twin Bed</li>
                                                <li><i class="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/s-room-2.webp" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Deluxe Twin/Double Room</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div className="col-md-6 col-6">
                                            <ul>
                                                <li><i class="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i class="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 col-6">
                                            <ul>
                                                <li><i class="flaticon-bed"></i> Twin Bed</li>
                                                <li><i class="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6 mb-30">
                            <div className="item">
                                <figure> <img src="img/rooms/s-room-3.webp" loading="lazy" alt="hotel" className="img-fluid" /> </figure>
                                <div className="desc">
                                    <h3 className="title"><Link to="#">Suite</Link></h3>
                                    <div className="row room-facilities mb-15">
                                        <div className="col-md-6 col-6">
                                            <ul>
                                                <li><i class="flaticon-group"></i> 1-2 Persons</li>
                                                <li><i class="flaticon-wifi"></i> Free Wifi</li>
                                            </ul>
                                        </div>
                                        <div className="col-md-6 col-6">
                                            <ul>
                                                <li><i class="flaticon-bed"></i> Single Bed</li>
                                                <li><i class="flaticon-breakfast"></i> Breakfast</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </div>
                </div>
                <div className="container">
                    <div className="row">

                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-2026-1.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-2026-1.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-2026-2.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-2026-2.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-2026-3.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-2026-3.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-2026-4.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-2026-4.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-2026-5.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-2026-5.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-3.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-3.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-4.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-4.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-15.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-15.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-5.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-5.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-6.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-6.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-7.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-7.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-8.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-8.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                       
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-9.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-9.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>

                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-17.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-17.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="col-md-3 gallery-item">
                            <div className="img-card">
                                <a href="img/gallery/sravasti-18.webp" title="" className="img-zoom">
                                    <div className="img-block">
                                        <div className="wrapper-img"> <img src="img/gallery/sravasti-18.webp" className="img-fluid mx-auto d-block" loading="lazy" alt="work-img" />
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>





                    </div>
                </div>
            </section>

            <section className="section-padding">
                <div className="container">
                    <div className="section-title">Places of Attraction</div>
                    <OwlCarousel className="owl-theme first-carousel" {...carouselSravastiResidencythumb}>
                        <div className="item thumb">
                            <img src='img/slider/Vibhuti.webp' alt='' />
                            <p>Vibhuti Nath Temple</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Suhaildev.webp' alt='' />
                            <p>Suhaildev Wildlife Sanctuary</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Kacchi.webp' alt='' />
                            <p>Kacchi Kuti</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Ungli.webp' alt='' />
                            <p>Ungli mar caves</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Patan.webp' alt='' />
                            <p>Patan devi Shakti peeth</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Vipassana.webp' alt='' />
                            <p>Vipassana Meditation Centre</p>
                        </div>

                        <div className="item thumb">
                            <img src='img/slider/Digambarjaintemple.webp' alt='' />
                            <p>Digambar Jain Temple</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Sambhav.webp' alt='' />
                            <p>Bhagwan Sambhav Nath Birthplace</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Anathpindika.webp' alt='' />
                            <p>Anathpindika Stupa</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Mongkol.webp' alt='' />
                            <p>Daen Maha Mongkol Chai</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Anand.webp' alt='' />
                            <p>Anand bodhi</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Gandhakuti.webp' alt='' />
                            <p>Gandhakuti</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Jetavana.webp' alt='' />
                            <p>Jetavana</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/World.webp' alt='' />
                            <p>World Peace Bell</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Koreatemple.webp' alt='' />
                            <p>Korea temple</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Koreatemplegallery.webp' alt='' />
                            <p>Korea temple gallery</p>
                        </div>
                        <div className="item thumb">
                            <img src='img/slider/Orajhar.webp' alt='' />
                            <p>Orajhar</p>
                        </div>


                    </OwlCarousel>

                </div>
            </section>

            <section className="bg-white">
                <div className="col-md-12">

                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3538.9307406852286!2d82.04260337446425!3d27.50252933449712!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3999daa945fa80d7%3A0xd6dc91ef36d8cb8!2sShravasti%20Residency!5e0!3m2!1sen!2sin!4v1747638129138!5m2!1sen!2sin"
                        width="100%"
                        height="350"
                        className="mappie"
                        title="Google Map - The Sravasti Residency"
                        loading="lazy"
                        allowFullScreen
                        referrerPolicy="no-referrer-when-downgrade"
                        style={{
                            border: 0,
                        }}
                    ></iframe>

                </div>

            </section>
        </>
    )
};

export default SravastiResidency;